<template>
  <v-navigation-drawer
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    clipped
    app
    width="350"
  >
    <v-list>
      <template v-for="(n, i) in nav">
        <v-list-item
          v-if="
            n.to &&
            !n.subItems &&
            (n.check_permission_condition === true
              ? check_permission(n.check_permission)
              : n.check_permission_condition === false
              ? !check_permission(n.check_permission)
              : true)
          "
          :key="`${i}-link`"
          :to="n.to"
          :href="n.href"
          :target="n.target"
          link
        >
          <v-list-item-icon class="mr-3">
            <v-icon class="white--text shadow">
              {{ n.icon }}
            </v-icon>
            <v-badge v-if="n.noti_badge" dot color="red"></v-badge>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text shadow">
              {{ $t(n.label) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-if="
            n.subItems &&
            (n.check_permission_condition === true
              ? check_permission(n.check_permission)
              : n.check_permission_condition === false
              ? !check_permission(n.check_permission)
              : true)
          "
          :key="`${i}-group`"
          v-model="n.active"
        >
          <template v-slot:activator>
            <v-list-item-icon class="mr-3">
              <v-icon class="white--text shadow">
                {{ n.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text shadow">
                {{ $t(n.label) }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:appendIcon>
            <v-icon class="white--text shadow"> mdi-chevron-down </v-icon>
          </template>
          <template v-for="(s, j) in n.subItems">
            <v-list-item
              v-if="
                s.check_permission_condition === true
                  ? check_permission(s.check_permission)
                  : s.check_permission_condition === false
                  ? !check_permission(s.check_permission)
                  : true
              "
              :key="`sub-${i}-${j}`"
              :to="s.to"
              :href="s.href"
              :target="s.target"
              link
              class="pl-8"
              @click="handleSubItemClick(s)"
            >
              <v-list-item-icon class="mr-3">
                <v-icon class="white--text shadow">
                  {{ s.icon }}
                </v-icon>
                <v-badge v-if="s.noti_badge" dot color="red"></v-badge>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text shadow">
                  {{ $t(s.label) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { check_permission } from "@/router/acl";

export default {
  components: {},

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    nav: [
      {
        to: "main_menu",
        label: "drawer.main_menu",
        icon: "mdi-microsoft-xbox-controller-menu",
        check_permission: ["main_menu"],
        check_permission_condition: true,
        active: false,
      },
      {
        to: "",
        label: "drawer.user_account",
        icon: "mdi-account",
        check_permission: null,
        check_permission_condition: null,
        active: false,
        subItems: [
          {
            to: "/",
            label: "app_bar.homepage",
            icon: "mdi-home",
            check_permission: ["home"],
            check_permission_condition: true,
          },
          {
            to: "/",
            label: "drawer.surrogate_student",
            icon: "mdi-account-multiple-outline",
            check_permission: ["surrogate_student"],
            check_permission_condition: true,
          },
          {
            to: "",
            label: "app_bar.login",
            icon: "mdi-login",
            check_permission: ["main_menu"],
            check_permission_condition: false,
            action: "login",
          },

          {
            to: "",
            label: "app_bar.logout",
            icon: "mdi-logout",
            check_permission: ["main_menu"],
            check_permission_condition: true,
            action: "logout",
          },
        ],
      },
      {
        to: "",
        label: "drawer.manual",
        icon: "mdi-book-open-variant",
        check_permission: null,
        check_permission_condition: null,
        active: false,
        subItems: [
          {
            href: "https://www.reg.kmitl.ac.th/storage/reg/ManualRegistration.pdf",
            target: "_blank",
            label: "drawer.undergraduate",
            icon: "mdi-book-open-variant",
            check_permission: null,
            check_permission_condition: null,
          },
          {
            href: "https://www.reg.kmitl.ac.th/storage/reg/ManualRegistration_postgraduate.pdf",
            target: "_blank",
            label: "drawer.postgraduate",
            icon: "mdi-book-open-variant",
            check_permission: null,
            check_permission_condition: null,
          },
          {
            href: "https://www.reg.kmitl.ac.th/storage/reg/ManualRegistration_officer.pdf",
            target: "_blank",
            label: "drawer.officer",
            icon: "mdi-book-open-variant",
            check_permission: ["registration_for_officer"],
            check_permission_condition: true,
          },
        ],
      },
      {
        to: "",
        label: "drawer.teach_table",
        icon: "mdi-table-clock",
        check_permission: null,
        check_permission_condition: null,
        active: false,
        subItems: [
          {
            to: { name: "teach_table_selector" },
            label: "drawer.undergraduate",
            icon: "mdi-table-clock",
            check_permission: null,
            check_permission_condition: null,
          },
          {
            to: { name: "graduate_teach_table_selector" },
            label: "drawer.postgraduate",
            icon: "mdi-table-clock",
            check_permission: null,
            check_permission_condition: null,
          },
        ],
      },
      {
        to: "",
        label: "drawer.registration_system",
        icon: "mdi-table-account",
        check_permission: [
          "information",
          "pre_registration",
          "registration",
          "student_timetable",
          "student_exam_timetable",
          "registration_x",
        ],
        check_permission_condition: true,
        active: false,
        subItems: [
          {
            to: "information",
            label: "information.title",
            icon: "mdi-information-outline",
            check_permission: ["information"],
            check_permission_condition: true,
          },
          {
            to: "pre_registration",
            label: "drawer.pre_registration",
            icon: "mdi-table-account",
            check_permission: ["pre_registration"],
            check_permission_condition: true,
          },
          {
            to: "registration",
            label: "drawer.registration",
            icon: "mdi-table-account",
            check_permission: ["registration"],
            check_permission_condition: true,
          },
          {
            to: "registration_future_innovation",
            label: "drawer.registration_future_innovation",
            icon: "mdi-table-account",
            check_permission: ["registration_future_innovation"],
            check_permission_condition: true,
          },
          {
            to: "registration_x",
            label: "drawer.registration",
            icon: "mdi-table-account",
            check_permission: ["registration_x"],
            check_permission_condition: true,
          },
          {
            to: "maintain_and_leave",
            label: "drawer.maintain_and_leave",
            icon: "mdi-table-heart",
            check_permission: ["registration", "registration_x"],
            check_permission_condition: true,
          },
          {
            to: "student_timetable",
            label: "drawer.student_timetable",
            icon: "mdi-calendar-clock",
            check_permission: ["student_timetable"],
            check_permission_condition: true,
          },
          {
            to: "student_exam_timetable",
            label: "drawer.student_exam_timetable",
            icon: "mdi-calendar-star",
            check_permission: ["student_exam_timetable"],
            check_permission_condition: true,
          },
          {
            to: "questionnaire",
            label: "questionnaire.title_short",
            icon: "mdi-comment-text-outline",
            check_permission: ["questionnaire"],
            check_permission_condition: true,
            noti_badge: false, // will be set dynamically in mounted()
          },
        ],
      },
      {
        to: "payment",
        label: "payment.title",
        icon: "mdi-currency-thb",
        check_permission: ["payment"],
        check_permission_condition: true,
        active: false,
        subItems: [
          {
            to: "payment",
            label: "drawer.pay_tuition_fee",
            icon: "mdi-cash-fast",
            check_permission: ["payment"],
            check_permission_condition: true,
          },
        ],
      },
      {
        to: "",
        label: "drawer.for_officer",
        icon: "mdi-account-tie",
        check_permission: [
          "registration_for_officer",
          "registration_queue",
          "payment_officer",
          "student_debt_report",
          "academic_data_edit",
        ],
        check_permission_condition: true,
        active: false,
        subItems: [
          {
            to: "registration_for_officer",
            label: "drawer.registration_for_officer",
            icon: "mdi-table-multiple",
            check_permission: ["registration_for_officer"],
            check_permission_condition: true,
          },
          {
            to: "payment_officer",
            label: "drawer.payment",
            icon: "mdi-cash-fast",
            check_permission: ["payment_officer"],
            check_permission_condition: true,
          },
          {
            to: "student_debt_report",
            label: "drawer.student_debt_report",
            icon: "mdi-account-cash-outline",
            check_permission: ["student_debt_report"],
            check_permission_condition: true,
          },
          {
            to: "registration_queue",
            label: "drawer.queue_list",
            icon: "mdi-account-clock-outline",
            check_permission: ["registration_queue"],
            check_permission_condition: true,
          },
          {
            to: "academic_data_edit",
            label: "drawer.academic_data_edit",
            icon: "mdi-account-edit-outline",
            check_permission: ["academic_data_edit"],
            check_permission_condition: true,
          },
        ],
      },
      {
        to: "",
        label: "english_graduate.title_short",
        icon: "mdi-alpha-e-box-outline",
        check_permission: ["registration_x", "english_submit_list"],
        check_permission_condition: true,
        active: false,
        subItems: [
          {
            to: "english_submit",
            label: "english_graduate.submit_english_score",
            icon: "mdi-arrow-up-bold-hexagon-outline",
            check_permission: ["registration_x"],
            check_permission_condition: true,
          },
          {
            to: "english_submit_list",
            label: "english_graduate.officer_title_short",
            icon: "mdi-file-document-check",
            check_permission: ["english_submit_list"],
            check_permission_condition: true,
          },
        ],
      },
      {
        to: "",
        label: "drawer.config",
        icon: "mdi-cog",
        check_permission: ["config_teach_table"],
        check_permission_condition: true,
        active: false,
        subItems: [
          {
            to: "graduate_officer_menu",
            label: "drawer.graduate_officer_menu",
            icon: "mdi-cog-outline",
            check_permission: ["graduate_officer_menu"],
            check_permission_condition: true,
          },
          {
            to: "config_individual_tuition_fee",
            label: "officer.config_individual_tuition_fee",
            icon: "mdi-account-cog",
            check_permission: ["config_individual_tuition_fee"],
            check_permission_condition: true,
          },
          {
            to: "config_schedule_permission",
            label: "schedule_permission.title",
            icon: "mdi-account-key",
            check_permission: ["config_schedule_permission"],
            check_permission_condition: true,
          },
          // {
          //   to: "config_medicine",
          //   label: "config_medicine.title",
          //   icon: "mdi-heart-cog",
          //   check_permission: ["config_medicine"],
          //   check_permission_condition: true,
          // },
          {
            to: "config_academic",
            label: "config_academic.title",
            icon: "mdi-cog-outline",
            check_permission: ["config_academic"],
            check_permission_condition: true,
          },
          {
            to: "config_payment",
            label: "config_payment.config_payment",
            icon: "mdi-cog-outline",
            check_permission: ["config_payment"],
            check_permission_condition: true,
          },
        ],
      },
    ],
  }),

  computed: {
    year() {
      return this.$store.state.registration.yearNow;
    },

    semester() {
      return this.$store.state.registration.semesterNow;
    },

    student_id() {
      return this.$store.state.user.surrogated_student_id;
    },

    level_id() {
      if (
        this.$store.state.user.surrogated_student_info.payload.ticket
          .privilege == 80
      )
        return 1;
      else return 2;
    },

    reviewed() {
      return this.$store.state.questionnaire.data.reviewed;
    },
  },

  methods: {
    check_permission,

    handleSubItemClick(item) {
      if (item.action === "login") {
        this.login();
      } else if (item.action === "logout") {
        this.logout();
      }
    },

    login() {
      this.$store.dispatch("keycloak/login");
    },
    logout() {
      this.$store.dispatch("user/logout");
    },

    async fetch() {
      if (this.student_id) {
        await this.$store.dispatch(
          "registration/getYearSemesterNow",
          this.level_id
        );
        await this.$store.dispatch("questionnaire/getQuestionnaire", {
          student_id: this.student_id,
          year: this.year,
          semester: this.semester,
        });

        // Dynamically set noti_badge for questionnaire subItem after fetching
        const registrationNav = this.nav.find(
          (item) => item.label === "drawer.registration_system"
        );
        if (registrationNav && registrationNav.subItems) {
          const questionnaireSubItem = registrationNav.subItems.find(
            (sub) => sub.to === "questionnaire"
          );
          if (questionnaireSubItem) {
            questionnaireSubItem.noti_badge = this.reviewed === false;
          }
        }
      }
    },
  },

  mounted() {
    setTimeout(() => {
      this.fetch();
    }, 3000);
  },
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0.7) !important;
  backdrop-filter: blur(5px);
}

.v-list {
  padding: 10px;
}

/* สำหรับ item ที่ไม่อยู่ใน group */
.v-list > .v-list-item {
  margin-bottom: 10px;
}

.v-list-group {
  border: 1px solid #888888;
  border-radius: 10px;
  margin-bottom: 10px;
}

.v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.7;
}

.v-list-group--active {
  border: 1px solid #e35205;
}

:deep(.v-list-group--active .v-list-group__header) {
  background-color: #e35205;
  border-radius: 7px 7px 0 0;
}

.v-list > .v-list-item--active .v-icon,
.v-list > .v-list-item--active .v-list-item__title,
.v-list-group__items > .v-list-item--active .v-icon,
.v-list-group__items > .v-list-item--active .v-list-item__title {
  color: #e35205 !important;
}

.v-list-item--active,
.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgba(0, 0, 0, 0.5) !important;
  border-radius: 7px;
}
</style>
